import CartaoHub from '@/pages/gerenciar/painel/CartaoHub';

export type TelaMais = 'sorteio' | 'avisos' | 'direcao' | 'recursos' | 'historico';

interface Props {
  /** A ação entre amigos só aparece no hub quando está ligada. */
  temRifa: boolean;
  /** Entrada franca que vende fichas: fala em arte/formulário e em fichas. */
  vendeFichas?: boolean;
  /** O relatório das crianças só faz sentido em evento que monta equipes. */
  mostrarCriancas?: boolean;
  aoAbrir: (tela: TelaMais) => void;
  aoEditar: () => void;
  aoAbrirCriancas?: () => void;
}

// Hub da aba "Mais" (o antigo Ajustes): um cartão por assunto.
export default function HubMais({
  temRifa,
  vendeFichas = false,
  mostrarCriancas = false,
  aoAbrir,
  aoEditar,
  aoAbrirCriancas,
}: Props) {
  return (
    <div className="space-y-2.5 lg:grid lg:grid-cols-3 lg:gap-3 lg:space-y-0">
      {temRifa && (
        <CartaoHub
          icone="ri-gift-line"
          titulo="Ação entre amigos"
          descricao="Prêmios, talões, ranking e números pagos"
          cor="accent"
          aoClicar={() => aoAbrir('sorteio')}
        />
      )}
      {mostrarCriancas && aoAbrirCriancas && (
        <CartaoHub
          icone="ri-user-smile-line"
          titulo="Crianças no acampamento"
          descricao="Remédios, alergias e autorização dos pais"
          cor="accent"
          aoClicar={aoAbrirCriancas}
        />
      )}
      <CartaoHub
        icone="ri-notification-3-line"
        titulo="Avisos no celular"
        descricao="Receber uma notificação a cada venda"
        cor="primary"
        aoClicar={() => aoAbrir('avisos')}
      />
      <CartaoHub
        icone="ri-shield-user-line"
        titulo="Quem está na direção"
        descricao="Quem mais cuida do evento, e convites"
        cor="secondary"
        aoClicar={() => aoAbrir('direcao')}
      />
      <CartaoHub
        icone="ri-edit-line"
        titulo="Editar evento"
        descricao={
          vendeFichas ? 'Nome, datas, arte e formulário' : 'Nome, datas, inscrições, ficha e capa'
        }
        cor="primary"
        aoClicar={aoEditar}
      />
      <CartaoHub
        icone="ri-toggle-line"
        titulo="Recursos ligados"
        descricao="Equipes, encontros, fichas e divulgação"
        cor="accent"
        aoClicar={() => aoAbrir('recursos')}
      />
      <CartaoHub
        icone="ri-history-line"
        titulo="Histórico"
        descricao="Tudo o que foi feito neste evento"
        cor="secondary"
        aoClicar={() => aoAbrir('historico')}
      />
    </div>
  );
}